/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import ContactInfo from './ContactInfo/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Insurance from './Insurance/index'
import Main from './Main/index'
import PracticeHub from './PracticeHub/index'
import Professionals from './Professionals/index'
import React from 'react'
import Relations from './Relations/index'
import SchedulingPreferences from './SchedulingPreferences/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content"
  
}) {
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<Main
  viewPath={`${viewPath}/Main`}
/>
<ContactInfo
  viewPath={`${viewPath}/ContactInfo`}
/>
<Relations
  viewPath={`${viewPath}/Relations`}
/>
<PracticeHub
  viewPath={`${viewPath}/PracticeHub`}
/>
<Professionals
  viewPath={`${viewPath}/Professionals`}
/>
<Insurance
  viewPath={`${viewPath}/Insurance`}
/>
<SchedulingPreferences
  viewPath={`${viewPath}/SchedulingPreferences`}
/>
</div>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
{children}
</React.Fragment>)
}